var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46993 0.40577C0.143995 0.796878 -0.0205165 1.29756 0.00992987 1.80577V23.9258C-0.0205165 24.434 0.143995 24.9347 0.46993 25.3258L0.53993 25.3958L12.9299 13.0158V12.7258L0.53993 0.33577L0.46993 0.40577Z",
    fill: "url(#paint0_linear_5961_137)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0299 17.1458L12.9299 13.0158V12.7258L17.0299 8.58577L17.1199 8.63577L22.0299 11.4258C23.4299 12.2158 23.4299 13.5158 22.0299 14.3158L17.1399 17.0958L17.0299 17.1458Z",
    fill: "url(#paint1_linear_5961_137)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 17.0858L12.93 12.8658L0.469971 25.3258C1.05869 25.8433 1.9324 25.8685 2.54997 25.3858L17.16 17.0858",
    fill: "url(#paint2_linear_5961_137)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 8.64577L2.53996 0.345773C1.92239 -0.136952 1.04868 -0.111749 0.459961 0.405773L12.93 12.8658L17.15 8.64577Z",
    fill: "url(#paint3_linear_5961_137)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.03 16.9958L2.53997 25.2458C1.94701 25.6891 1.13293 25.6891 0.539971 25.2458L0.469971 25.3158L0.539971 25.3858C1.13182 25.8325 1.94812 25.8325 2.53997 25.3858L17.15 17.0858L17.03 16.9958Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0299 16.9958L22.0299 14.1658C22.5466 13.9107 22.916 13.4306 23.0299 12.8658C22.9784 13.4902 22.597 14.0394 22.0299 14.3058L17.1199 17.0858L17.0299 16.9958ZM0.00775433 23.9804C0.0242669 24.4204 0.185735 24.8447 0.46993 25.1858L0.53993 25.2658L0.46993 25.3358C0.153548 24.9561 -0.0107342 24.4732 0.00775433 23.9804ZM0.00775433 23.9804C0.00831259 23.9656 0.00903749 23.9507 0.00992987 23.9358V23.7858C0.00603079 23.8509 0.00532909 23.9158 0.00775433 23.9804Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M2.54 0.485767L22.03 11.5658C22.5467 11.8208 22.916 12.3009 23.03 12.8658C22.9785 12.2414 22.5971 11.6922 22.03 11.4258L2.54 0.345767C1.14 -0.444233 0 0.215767 0 1.81577V1.96577C0.03 0.355767 1.15 -0.304233 2.54 0.485767V0.485767Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5961_137",
    x1: 7.50316,
    y1: -14.6932,
    x2: -12.3363,
    y2: -9.41686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5961_137",
    x1: 23.8599,
    y1: 2.66545,
    x2: -0.330068,
    y2: 2.66545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5961_137",
    x1: 0.103861,
    y1: 6.3933,
    x2: -15.8326,
    y2: 33.1999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5961_137",
    x1: -9.26002,
    y1: -3.03822,
    x2: -2.14674,
    y2: 8.93225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/Icon-google.e22ac44d8fd496c4a4b93e17da58994b.svg";
export { ForwardRef as ReactComponent };